/**
 * ImageKitApi - Service for ImageKit file management operations
 *
 * Note: This uses the ImageKit REST API with the private key exposed client-side.
 * This is the accepted security tradeoff for this application.
 */
class ImageKitApi {
  constructor() {
    this.privateKey = process.env.REACT_APP_IMAGEKIT_PRIVATE_KEY;
    this.baseUrl = "https://api.imagekit.io/v1";
  }

  /**
   * Get authorization header for ImageKit API calls
   */
  getAuthHeader() {
    const credentials = btoa(`${this.privateKey}:`);
    return `Basic ${credentials}`;
  }

  /**
   * Permanently delete a file from ImageKit
   * @param {string} fileId - The ImageKit fileId
   */
  async deleteFile(fileId) {
    if (!fileId) {
      return { success: false, error: "File ID is required" };
    }

    try {
      const response = await fetch(`${this.baseUrl}/files/${fileId}`, {
        method: "DELETE",
        headers: {
          Authorization: this.getAuthHeader(),
        },
      });

      if (response.status === 204) {
        return { success: true };
      }

      const data = await response.json();
      return { success: false, error: data.message || "Failed to delete file" };
    } catch (error) {
      console.error("Error deleting file from ImageKit:", error);
      return { success: false, error: error.message };
    }
  }
}

export default ImageKitApi;
